__turbopack_context__.v({
  "description": "TextInput-module__iRz-8G__description",
  "error": "TextInput-module__iRz-8G__error",
  "input": "TextInput-module__iRz-8G__input",
  "label": "TextInput-module__iRz-8G__label",
  "required": "TextInput-module__iRz-8G__required",
  "section": "TextInput-module__iRz-8G__section",
});
